import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useCurrentUser } from '../Session';
import { UserType } from '../api';

const useUserTypeOptionsForManagement = () => {
    const { t } = useTranslation(['common']);
    const currentUser = useCurrentUser();

    return useMemo(
        () =>
            currentUser?.type === UserType.Admin
                ? [
                      { value: UserType.Admin, label: t('common:userTypes.admin') },
                      { value: UserType.Dealer, label: t('common:userTypes.dealer') },
                      { value: UserType.Purchaser, label: t('common:userTypes.purchaser') },
                      { value: UserType.SaleConsultant, label: t('common:userTypes.salesConsultant') },
                      { value: UserType.SalesManager, label: t('common:userTypes.salesManager') },
                  ]
                : [
                      { value: UserType.Dealer, label: t('common:userTypes.dealer') },
                      { value: UserType.Purchaser, label: t('common:userTypes.purchaser') },
                      { value: UserType.SaleConsultant, label: t('common:userTypes.salesConsultant') },
                  ],

        [currentUser?.type, t]
    );
};

export default useUserTypeOptionsForManagement;
